module.exports = __webpack_public_path__ + "static/media/rodrigo-ardilha.5577a0d8.jpg";